<template>
  <header class="header">
    <div class="container-fluid">
      <div class="header-inner">
        <div class="header__side">
          <router-link to="/" class="header__logo"><img src="/images/useful/svg/logo.svg" alt="logo"/></router-link>
        </div>
        <div class="header__side header__side-nav" v-if="mode === 'full' && user">
          <nav id="header_navigation_menu" :class="['header__nav-wrap', { 'nav-open' : isOpen }]"
               :style="{overflow: hiddened ? 'hidden' : 'visible'}">
            <ul class="header__nav h-reset-list">
              <li v-if="!user.scope.includes('ACCOUNTANT')" :class="['header__nav__item', { 'active' : $route.name === 'create' ||  $route.name === 'template' ||  $route.name === 'client' }]">
                <router-link to="/new"><span>Make a Story</span></router-link>
              </li>
              <li v-if="!user.scope.includes('ACCOUNTANT')" :class="['header__nav__item', { 'active' : $route.name === 'clients' }]">
                <router-link to="/clients"><span>My Clients</span></router-link>
              </li>
              <li v-if="!user.scope.includes('ACCOUNTANT')" :class="['header__nav__item', { 'active' : $route.name === 'templates' }]">
                <router-link to="/templates"><span>My Templates</span></router-link>
              </li>
              <li :class="['header__nav__item', { 'active' : $route.name === 'hotels' }]">
                <router-link to="/hotels"><span>Hotel Database</span></router-link>
              </li>


              <li :class="['header__nav__item', 'header__nav__item--sub', { 'is-active' : nav.nav1, 'active' : $route.name !== 'create' &&  $route.name === 'template' && $route.name === 'client' && $route.name !== 'clients' && $route.name !== 'templates' && $route.name !== 'managers' }]"
                  @click.stop="nav.nav1 = !nav.nav1"
                  v-if="user.scope.includes('ADMIN') || user.scope.includes('CONTENT')">
                <a href="javascript:void(0)"> <span>Settings</span>
                  <svg width="1em" height="1em" class="icon icon-chevron ">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                  </svg>
                </a>
                <ul class="header__sublist h-reset-list">
                  <li :class="['header__sublist__item header__sublist__item--sub', { 'is-active' : nav.nav2 }]"
                      @click.stop="nav.nav2 = !nav.nav2">
                    <a href="javascript:void(0)"><span>Climbing</span>
                      <div class="header__sublist__item__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron ">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                        </svg>
                      </div>
                    </a>
                    <ul class="header__submenu h-reset-list">
                      <li class="header__sublist__item">
                        <router-link to="/climbing/routes"
                                     v-if="user.scope.includes('ADMIN') || user.scope.includes('CONTENT')"><span>Climbing Routes</span>
                        </router-link>
                      </li>
                      <li :class="['header__sublist__item header__sublist__item--sub', { 'is-active' : nav.sublist1 }]"
                          @click.stop="nav.sublist1 = !nav.sublist1" v-if="user.scope.includes('ADMIN')"><a
                          href="javascript:void(0)"><span>Climbing Settings</span>
                        <div class="header__sublist__item__icon">
                          <svg width="1em" height="1em" class="icon icon-chevron ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                          </svg>
                        </div>
                      </a>
                        <ul class="header__submenu h-reset-list">
                          <li class="header__submenu__item">
                            <router-link to='/climbing/camps'><span>Camps & Heights</span></router-link>
                          </li>
                          <li class="header__submenu__item">
                            <router-link to='/climbing/distance'><span>Distance & Time</span></router-link>
                          </li>
                          <li class="header__submenu__item">
                            <router-link to='/climbing/temperature'><span>Temperature</span></router-link>
                          </li>
                          <li class="header__submenu__item">
                            <router-link to='/climbing/moon'><span>Moon Phases</span></router-link>
                          </li>
                          <li class="header__submenu__item">
                            <router-link to='/climbing/additional'><span>Additional options</span></router-link>
                          </li>
                          <li class="header__submenu__item">
                            <router-link to='/climbing/prices'><span>Prices</span></router-link>
                          </li>
                          <li class="header__submenu__item">
                            <router-link to='/climbing/inclusions'><span>Inclusions</span></router-link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li :class="['header__sublist__item header__sublist__item--sub', { 'is-active' : nav.nav3 }]"
                      @click.stop="nav.nav3 = !nav.nav3"><a href="javascript:void(0)"><span>Safari</span>
                    <div class="header__sublist__item__icon">
                      <svg width="1em" height="1em" class="icon icon-chevron ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                      </svg>
                    </div>
                  </a>
                    <ul class="header__submenu h-reset-list">
                      <li class="header__sublist__item">
                        <router-link to="/safari/calculation" v-if="user.scope.includes('ADMIN')"><span>Calculation Settings</span>
                        </router-link>
                      </li>
                      <li class="header__sublist__item">
                        <router-link to="/safari/parks"
                                     v-if="user.scope.includes('ADMIN') || user.scope.includes('CONTENT')"><span>National Parks</span>
                        </router-link>
                      </li>
                    </ul>
                  </li>
                  <li :class="['header__sublist__item header__sublist__item--sub', { 'is-active' : nav.nav4 }]"
                      @click.stop="nav.nav4 = !nav.nav4">
                    <a href="javascript:void(0)"><span>Day Trips & Activities</span>
                      <div class="header__sublist__item__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron ">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                        </svg>
                      </div>
                    </a>
                    <ul class="header__submenu h-reset-list">
                      <li class="header__sublist__item">
                        <router-link to="/trips/tanzania"><span>Tanzania Day trips</span></router-link>
                      </li>
                      <li class="header__sublist__item">
                        <router-link to="/trips/safari"><span>Safari Activities</span></router-link>
                      </li>
                      <li class="header__sublist__item">
                        <router-link to="/trips/island"><span>Island Activities</span></router-link>
                      </li>
                    </ul>
                  </li>
                  <li class="header__sublist__item">
                    <router-link to='/banks'><span>Bank Settings</span></router-link>
                  </li>
                  <li class="header__sublist__item">
                    <router-link to='/partners'><span>Partners</span></router-link>
                  </li>
                  <li class="header__sublist__item">
                    <router-link to='/domestic' v-if="user.scope.includes('ADMIN')"><span>Domestic Flights</span>
                    </router-link>
                  </li>
                  <li class="header__sublist__item">
                    <router-link to='/settings/texts' v-if="user.scope.includes('ADMIN')"><span>Added texts</span>
                    </router-link>
                  </li>
                  <li :class="['header__sublist__item header__sublist__item--sub', { 'is-active' : nav.nav5 }]"
                      @click.stop="nav.nav5 = !nav.nav5" v-if="user.scope.includes('ADMIN')">
                    <a href="javascript:void(0)"><span>Settings & Data</span>
                      <div class="header__sublist__item__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron ">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                        </svg>
                      </div>
                    </a>
                    <ul class="header__submenu h-reset-list">
                      <li :class="['header__sublist__item header__sublist__item--sub', { 'is-active' : nav.sublist2 }]"
                          @click.stop="nav.sublist2 = !nav.sublist2"><a href="javascript:void(0)"><span>General</span>
                        <div class="header__sublist__item__icon">
                          <svg width="1em" height="1em" class="icon icon-chevron ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                          </svg>
                        </div>
                      </a>
                        <ul class="header__submenu h-reset-list">
                          <li class="header__submenu__item">
                            <router-link to='/settings/exchange'><span>Exchange rate</span></router-link>
                          </li>
                          <li class="header__submenu__item">
                            <router-link to='/settings/smtp'><span>SMTP</span></router-link>
                          </li>
                          <li class="header__submenu__item">
                            <router-link to='/settings/commission'><span>Commission adviced</span></router-link>
                          </li>
                          <li class="header__submenu__item">
                            <router-link to='/settings/limits'><span>Limits</span></router-link>
                          </li>
                          <li class="header__submenu__item">
                            <router-link to='/settings/email-template'><span>Email Templates</span></router-link>
                          </li>
                        </ul>
                      </li>
                      <li :class="['header__sublist__item header__sublist__item--sub', { 'is-active' : nav.sublist3 }]"
                          @click.stop="nav.sublist3 = !nav.sublist3"><a href="javascript:void(0)"><span>Geo</span>
                        <div class="header__sublist__item__icon">
                          <svg width="1em" height="1em" class="icon icon-chevron ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                          </svg>
                        </div>
                      </a>
                        <ul class="header__submenu h-reset-list">
                          <li class="header__submenu__item">
                            <router-link to='/settings/territory'><span>Territory</span></router-link>
                          </li>
                          <li class="header__submenu__item">
                            <router-link to='/settings/location'><span>Location</span></router-link>
                          </li>
                          <li class="header__submenu__item">
                            <router-link to='/settings/area'><span>Area</span></router-link>
                          </li>
                          <li class="header__submenu__item">
                            <router-link to='/settings/airstrip'><span>Airstrip</span></router-link>
                          </li>
                        </ul>
                      </li>
                      <li class="header__sublist__item">
                        <router-link to="/settings/transfer"><span>Transfer Prices</span></router-link>
                      </li>
                      <li class="header__sublist__item">
                        <router-link to="/settings/mountains"><span>Mountains</span></router-link>
                      </li>
                      <li class="header__sublist__item">
                        <router-link to="/settings/vip-service"><span>VIP Services</span></router-link>
                      </li>
                    </ul>
                  </li>
                  <li class="header__sublist__item">
                    <router-link to='/settings/aircrafts' v-if="user.scope.includes('ADMIN')"><span>Aircrafts</span>
                    </router-link>
                  </li>
                </ul>
              </li>

              <li :class="['header__nav__item header__nav__item--sub', { 'is-active' : nav.nav6 }]" @click.stop="nav.nav6 = !nav.nav6"
                  v-if="user.scope.includes('ADMIN')">
                <a href="javascript:void(0)"> <span>Administration</span>
                  <svg width="1em" height="1em" class="icon icon-chevron ">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                  </svg>
                </a>
                <ul class="header__sublist h-reset-list">
                  <li v-if="user.scope.includes('ADMIN')" class="header__sublist__item">
                    <router-link to='/managers'><span>Managers</span></router-link>
                  </li>
                  <li v-if="(user.scope.includes('ADMIN') && user.scope.includes('SALES')) || user.scope.includes('ADMIN') || user.scope.includes('SALES')" class="header__sublist__item">
                    <router-link to="/all-clients"><span>All Clients</span></router-link>
                  </li>
                </ul>
              </li>
              <li v-if="user.scope.includes('ADMIN') || user.scope.includes('SALES') || user.scope.includes('ACCOUNTANT')"  :class="['header__nav__item header__nav__item--sub', { 'is-active' : nav.nav6 }]"
                  @click.stop="nav.nav6 = !nav.nav6">
                <a href="javascript:void(0)"> <span>Invoices</span>
                  <svg width="1em" height="1em" class="icon icon-chevron ">
                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                  </svg>
                </a>
                <ul class="header__sublist h-reset-list">
                  <li v-if="user.scope.includes('ADMIN') || user.scope.includes('ACCOUNTANT')" class="header__sublist__item">
                    <router-link to="/efd"><span>EFD Invoices</span></router-link>
                  </li>
                  <li v-if="(user.scope.includes('ADMIN') && user.scope.includes('SALES')) || user.scope.includes('ADMIN') || user.scope.includes('SALES') || user.scope.includes('ACCOUNTANT')" class="header__sublist__item">
                    <router-link to="/allInvoices"><span>All Invoices</span></router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
          <div class="header__user-side" v-if="user"><a href="javascript:void(0)" class="header__user">
            <div class="header__user__icon h-object-fit">
              <img v-if="user.data.photo" :src="`${API}/documents/share/images/${user.data.photo}?size=SMALL`"
                   alt="image"/>
              <span v-if="!user.data.photo"></span>
            </div>
            <span class="header__user__name">{{ user.data.firstName }}</span></a>
            <a href="javascript:void(0)" @click="$emit('logoutUser')" class="header__logout">
              <svg width="1em" height="1em" class="icon icon-logout ">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-logout"></use>
              </svg>
              <span>Log out</span></a>
            <button type="button" class="header__burger-menu js-nav-trigger" @click.stop="isOpen = !isOpen">
              <svg width="1em" height="1em" class="icon icon-burger ">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-burger"></use>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

import {API} from '@/utilites/api'

export default {
  props: ['mode', 'user'],
  data() {
    return {
      isOpen: false,
      hiddened: false,
      nav: {
        nav1: false,
        nav2: false,
        nav3: false,
        nav4: false,
        nav5: false,
        nav6: false,
        sublist1: false,
        sublist2: false,
        sublist3: false,
      },
      API
    }
  },
  mounted() {
    this.$router.beforeEach((to, from, next) => {
      this.isOpen = false;
      window.addEventListener('click', event => {
        if (!event.target.closest('.header__nav-wrap')) {
          this.isOpen = false;
        }
      })
      this.hiddened = true
      setTimeout(() => {
        this.hiddened = false
      }, 500)
      next()
    })
  }
}
</script>
